module.exports = __webpack_public_path__ + "img/band-3.627ce946.png";